export const LANG_LIST = ["en", "mh", "fr", "gr", "sp", "ch"];
